export default "assets/images/studies-7ad46215.jpg";